import topicsEvents from './topics';
import reviewsEvents from './reviews';
import sentimentEvenets from './sentiment';
import annotationsEvents from './annotations';
import keywordsCloudEvents from './keywordsCloud';
import trendingKeywordsEvents from './trendingKeywords';

export default {
    topics: topicsEvents,
    reviews: reviewsEvents,
    sentiment: sentimentEvenets,
    annotations: annotationsEvents,
    keywordsCloud: keywordsCloudEvents,
    trendingKeywords: trendingKeywordsEvents
};
